import React, {PureComponent} from "react"
import gql from "graphql-tag"
import PropTypes from "prop-types"

import {Query as QueryComponent} from "../"
import {insightsDemoTenant as insightsDemoTenantFields} from "../../gql"


export const insightsDemoTenantQuery = gql`
  query InsightsDemoTenant($params: InsightsDemoTenantParams!) {
    insightsDemoTenant(params: $params) {
      ${insightsDemoTenantFields}
    }
  }`

class InsightsDemoTenantQuery extends PureComponent {
  static propTypes = {
    children: PropTypes.func.isRequired,
    locale: PropTypes.string.isRequired
  }

  render() {
    const {children, locale, ...props} = this.props
    const params = {
      locale
    }

    return (
      <QueryComponent
        {...props}
        variables={{params}}
        query={insightsDemoTenantQuery}>
        {({data: {insightsDemoTenant} = {}, ...apolloState}) => {
          return children({insightsDemoTenant, ...apolloState})
        }}
      </QueryComponent>
    )
  }
}


export default InsightsDemoTenantQuery
